import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';

import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from '../../../app.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    user: any;

    baseUrl = myGlobals.baseFileUrl;
    baseBackUrl = myGlobals.baseUrl;
    constructor(private service: LandingServiceService, public router: Router) { }
    images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/360`);
    imgItem = [0, 1, 2, 3, 4, 5, 6, 7].map((n) => `https://picsum.photos/id/${n}/1000/650`);

    imageObject: Array<object> = [{
        image: `https://picsum.photos/id/1/900/600`,
        thumbImage: `https://picsum.photos/id/1/257/166`,
        alt: 'alt of image',
        title: 'title of image 1'
    }, {
        image: `https://picsum.photos/id/2/900/600`,
        thumbImage: `https://picsum.photos/id/2/257/166`,
        alt: 'alt of image',
        title: 'title of image 2'
    }, {
        image: `https://picsum.photos/id/3/900/600`,
        thumbImage: `https://picsum.photos/id/3/257/166`,
        alt: 'alt of image',
        title: 'title of image 3'
    }, {
        image: `https://picsum.photos/id/4/900/600`,
        thumbImage: `https://picsum.photos/id/4/257/166`,
        alt: 'alt of image 4',
        title: 'title of image'
    }
    ];
    banners: any[] = [];
    events: any;
    news: any[] = [];
    announcements: any[] = [];
    // quotes:any[]=['Quote-1.jpg','Quote-2.jpg','Quote-3.jpg','Quote-4.jpg','Quote-5.jpg','Quote-6.jpg','Quote-7.jpg','Quote-8.jpg','Quote-9.jpg','Quote-10.jpg'];
    eminents: any[]=[];
    ngOnInit(): void {
        this.getEvents();
        this.getNews();
        this.getCount();
        this.getAnnouncement();
        this.getBanner();
        this.getEminents();
    }
    getBanner() {
        this.service.getAllBanners().subscribe(data => this.setBanners(data));

    }
    setBanners(data) {
        this.banners = []
        for (let i = 0; i < data['banners'].length; i++) {
            this.banners.push(data['banners'][i])
        }
    }

    getEminents() {
        this.service.getAllEminents().subscribe(data => this.setEminents(data));

    }
    setEminents(data) {
        this.eminents = []
        for (let i = 0; i < data['eminents'].length; i++) {
            this.eminents.push(data['eminents'][i])
        }
    }

    getAnnouncement() {
        this.service.getAllHomeAnnouncement().subscribe(data => this.setAnnouncments(data));

    }
    setAnnouncments(data: Object): void {
        this.announcements = []
        for (let i = 0; i < data['Announcements'].length; i++) {
            this.announcements.push(data['Announcements'][i])
        }
    }
    getEvents() {
        this.service.getSingleEvents().subscribe(data => this.setEvents(data));
    }

    setEvents(data) {
        this.events = data['events']
    }
    getNews() {
        this.service.getAllNews().subscribe(data => this.setNews(data));
    }

    setNews(data) {
        this.news = []
        for (let i = 0; i < data['news'].length; i++) {
            this.news.push(data['news'][i])
        }

    }
    getCount() {
        this.service.getUserCount().subscribe(data => this.setCount(data));

    }
    setCount(data) {
        this.user = data
    }

    openAnnouncementLink(data){
        window.open(this.baseBackUrl+'/downloadAnnouncementHomepage?id='+window.btoa(data), '_blank').focus();
    }

    customOptions: OwlOptions = {
        loop: true,
        autoplay: true,
        center: false,
        dots: true,
        navText: [ '<i class="fa-chevron-left"></i>', '<i class="fa-chevron-right></i>"' ],
        nav: false,
        navSpeed: 700,
        margin: 10,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1000: {
            items: 2,
          }
        }
      }

      routeByUrl(data){
        // console.log(data);
        window.open(data);
      }
}

